import { useEffect, useState, useRef, useContext, useCallback } from "react";
import { DataTable, DataTableExpandedRows } from "primereact/datatable";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import { FilterMatchMode, FilterService } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import PdfCreator from "../../../components/generate-pdf-from-data/generatePdfFromData";
import "./index.css";
import "../shared/estadoDialog.css";
import Avatar from "/src/assets/images/male-avatar.png";
import * as api from "../../../utils/Api.ts";
import UploadFile from "../../widgets/UploadFile.tsx";
import DownloadFiles from "../../widgets/DownloadFiles.tsx";
import {
  appEnv,
  CENTRO_COSTO_ADQUISICION,
  CENTRO_COSTO_GENERAL,
  FILTER_ITEMS_BY_DOC_TYPE,
  FORMAT_CURRENCY,
  FORMAT_CURRENCY_AND_DOTS,
  parseNumberCommaFormatForOperations,
  USUARIO_CONFIRMA_GTE_GENERAL,
  USUARIO_TI,
  VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT,
} from "../../../utils/Constants.tsx";
import { InitDataContext } from "../../../context/InitDataContext.tsx";
import { InitDataForTablesContext } from "../../../context/InitDataForTables.tsx";
import { InputNumber } from "primereact/inputnumber";
import DropdownFilter from "../../dropdown/DropdownFilter.tsx";
import { FloatLabel } from "primereact/floatlabel";
import ModalConfirm from "../../ui/modal/ModalConfirm.tsx";
import ModalSignature from "../../ui/modal/ModalSignature";
import ModalLoadSpinner from "../../ui/modal/ModalLoadSpinner.tsx";
import EstadosSolicitudLeyenda from "./EstadosSolicitudLeyenda.tsx";
import CargandoDatos from "../shared/CargandoDatos.tsx";
import { useScrollbarGutter } from "../../reportes/reportesUtils.ts";
import { Toast } from "primereact/toast";
import { showMsg } from "../../../utils/Constants.tsx";
import { useNavigate, useSearchParams } from "react-router-dom";
import DOMPurify from "dompurify";

type Detalle = {
  cantidad: any;
  item: any;
  centrocosto: any;
  proveedor: any;
  preciorefunitario: any;
  preciorefunitariototal: any;
  detalles: string;
};

type Solicitud = {
  tiposolicitud: number;
  mesgasto: number;
  estadooperacional: number;
  tipomoneda: number;
  detalles: Detalle[];
};

type EmptyDetail = {
  cantidad: number;
  id_item: number;
  id_centro_costo_asociado: number;
  id_proveedor: number;
  observaciones: string;
  precio_unitario_ref: number;
  precio_total_ref: number;
  id_estado_solicitud: number;
  dt_cre: Date;
  dt_mod: Date;
};

function TableDataMaintenance({ contextmenu }: { contextmenu: string }) {
  const solicitudes = useRef();
  const solicitudesDetalles = useRef();
  const { initData, parametros } = useContext(InitDataContext);
  const navigate = useNavigate();

  const {
    itemsAdquisicion,
    centrosCosto,
    centrosCostoFull,
    proveedores,
    tipoSolicitudes,
    meses,
    estadosOperacionales,
    tiposMoneda,
    estadosSolicitud,
    tiposItemsAdquisicion,
    aprobadores,
    aprobadoresFull,
  } = useContext(InitDataForTablesContext);
  /******************************* FILTER ITEMS *******************************/
  const itemsFiltered = useRef(itemsAdquisicion);
  useEffect(() => {
    if (itemsFiltered.current.length == 0) {
      itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
        itemsAdquisicion,
        0,
        tiposItemsAdquisicion,
      );
    }
  }, [itemsAdquisicion]);

  const [goHome, setGoHome] = useState(false);
  useEffect(() => {
    if (goHome) {
      //navigate("/solicitudes-compra/mantencion", { replace: true });
      window.location.reload();
    }
  }, [goHome]);

  const [selectedCantidad, setSelectedCantidad] = useState<number>(0);
  //const [selectedItemId, setSelectedItemId] = useState<number>(0);
  //const [selectedItem, setSelectedItem] = useState<string>("Seleccione...");
  const [selectedItemId, setSelectedItemId] = useState(0);
  const [selectedItem, setSelectedItem] = useState("Seleccione...");
  const [selectedProveedorId, setSelectedProveedorId] = useState<number>(0);
  const [selectedProveedor, setSelectedProveedor] =
    useState<string>("Seleccione...");
  const [selectedPrecioUnitarioRef, setselectedPrecioUnitarioRef] =
    useState<number>(0);
  const [selectedPrecioTotalRef, setSelectedPrecioTotalRef] =
    useState<number>(0);
  const selectedDetalles = useRef<string>();
  const [selectedEstado, setSelectedEstado] = useState<string>("");
  const [selectedEstadoId, setSelectedEstadoId] = useState<number>(0);
  const [selectedMesGastoId, setSelectedMesGastoId] = useState<number>(0);
  const [selectedMesGasto, setSelectedMesGasto] = useState<string>("");
  const [selectedTipoSolicitudId, setSelectedTipoSolicitudId] =
    useState<number>(0);
  const [selectedTipoSolicitud, setSelectedTipoSolicitud] =
    useState<string>("Seleccione...");
  const [selectedEstadoOpId, setSelectedEstadoOpId] = useState<number>(0);
  const [selectedEstadoOp, setSelectedEStadoOp] =
    useState<string>("Seleccione...");
  const [selectedTipoMonedaId, setSelectedTipoMonedaId] = useState<number>(0);
  const [selectedTipoMoneda, setSelectedTipoMoneda] =
    useState<string>("Seleccione...");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [jsonDataSolicitud, setJsonDataSolicitud] = useState<Solicitud>();
  const [selectedNumeroSolicitud, setSelectedNumeroSolicitud] =
    useState<number>(0);
  const [selectedDetailRowId, setSelectedDetailRowId] = useState<number>(0);
  const selectedJustificacion = useRef();
  const solicitudesApprovalStates = useRef<any[]>([]);
  const solicitudesSignApprovalHistory = useRef<any[]>([]);
  const [showModalLoadSpinner, setShowModalLoadSpinner] = useState(false);
  const [needFetchingSoc, setNeedFetchingSoc] = useState(false);
  const [selectedAprobadorId, setSelectedAprobadorId] = useState<number>(0);
  const [selectedAprobador, setSelectedAprobador] =
    useState<string>("Seleccione...");
  const [searchParams, setSearchParams] = useSearchParams();
  //OBJETO PARA EL MODAL DE NUEVO DETALLE
  let emptyNewDetalle = {
    cantidad: 0,
    id_item: 0,
    id_centro_costo_asociado: 0,
    id_proveedor: 0,
    observaciones: "",
    precio_unitario_ref: 0,
    precio_total_ref: 0,
    id_estado_solicitud: 1,
    dt_cre: new Date(),
    dt_mod: new Date(),
    aprobador_id: 0,
    aprobador_nombre: "",
  };

  const rolesDeconstructedVal = initData.roles.some(
    (role: { codigo: string }) =>
      role.codigo === "APRSOC" || role.codigo === "CONFSOC",
  );

  const subroganteVal =
    !!initData.mi_subrogancia_soc &&
    initData.mi_subrogancia_soc.trim().length > 0
      ? true
      : false;

  const fetchSolicitudes = async () => {
    const responseGetSolicitudes =
      await api.GET_SOLICITUDES_ORDENES.getSolicitudesOrdenes(
        initData.id_centro_costo,
        contextmenu,
        initData.id,
        initData.centros_costo_vista,
        rolesDeconstructedVal,
        subroganteVal,
      );

    if (responseGetSolicitudes !== null) {
      solicitudes.current = responseGetSolicitudes;
      const responseGetSolicitudesDetails =
        await api.GET_SOLICITUDES_DETALLE_ORDENES.getSolicitudesDetalleOrdenes(
          initData.id_centro_costo,
          initData.roles.toString(),
          contextmenu,
          initData.id,
          initData.centros_costo_vista,
          rolesDeconstructedVal,
          subroganteVal,
        );
      if (responseGetSolicitudesDetails !== null) {
        solicitudesDetalles.current = responseGetSolicitudesDetails;
        //MERGE ARRAYS
        let parent: Array<any> = solicitudes.current as unknown as Array<any>;
        let detalle: Array<any> =
          solicitudesDetalles.current as unknown as Array<any>;

        function callback(obj: any) {
          const childs = detalle?.filter(
            (childObj: any) =>
              childObj["socdet_id_solicitud_orden_compra"] === obj["soc_id"],
          );

          let childArray = [];
          if (obj.detalle !== undefined) {
            childArray = obj.detalle;
          }
          childArray = [...childArray, ...childs];

          const textoBusqueda =
            `${obj.nombres || ""} ${obj.apellidos || ""} ${obj.cc_nombre || ""}`.toLowerCase();

          const ocIdsCombinados = childArray
            .map((c: any) => c.oc_id) // Usamos el campo real que mencionas
            .filter(
              (value, index, self) => value && self.indexOf(value) === index,
            ) // Quitamos nulos y duplicados
            .join(", ");

          const aprobadoresCombinados = childArray
            .map((c: any) => c.suda_nombre_usuario) // Usamos el campo real que mencionas
            .filter(
              (value, index, self) => value && self.indexOf(value) === index,
            ) // Quitamos nulos y duplicados
            .join(", ");

          // Centros de costo destino: los de las lineas de detalle
          // (sdetcc2; sdetcc es el del solicitante). Texto "id - nombre".
          const centrosCostoDestino = childArray
            .map((c: any) =>
              c.sdetcc2_id || c.sdetcc2_nombre
                ? `${c.sdetcc2_id ?? ""} - ${String(c.sdetcc2_nombre ?? "").trim()}`
                : null,
            )
            .filter(
              (value, index, self) => value && self.indexOf(value) === index,
            )
            .join(" | ");

          return {
            ...obj,
            detalle: childArray,
            busqueda_solicitante: textoBusqueda,
            oc_id: ocIdsCombinados,
            aprobadores_combinados: aprobadoresCombinados,
            centros_costo_destino: centrosCostoDestino,
          };
        }
        const result = parent ? parent.map(callback) : [];

        setData(result);
        setNeedFetchingSoc(false);
      } else {
        showMsg(
          toast,
          "error",
          "Error",
          "Error capturando datos de detalle de soc",
        );
      }
    } else {
      showMsg(toast, "error", "Error", "Error capturando datos de soc");
    }
  };

  useEffect(() => {
    if (!needFetchingSoc) return;
    // La primera carga (exitosa o no) termina el estado "cargando datos"
    fetchSolicitudes().finally(() => setCargandoDatos(false));
  }, [needFetchingSoc]);

  const fetchDatosAprobacionesConfirmaciones = async (idSolicitude: number) => {
    const responseGetSolicitudesStatesApproval =
      await api.GET_SOLICITUDE_APPROVALS_STATES.getSolicitudesApprovalStates(
        idSolicitude,
      );
    if (responseGetSolicitudesStatesApproval !== null) {
      solicitudesApprovalStates.current = responseGetSolicitudesStatesApproval;
    } else {
      showMsg(
        toast,
        "error",
        "Error",
        "Error capturando datos de estados de la solicitud",
      );
    }
  };

  const fetchDatosFirmaAprobacionesConfirmaciones = async (
    idSolicitude: number,
  ) => {
    const responseGetSignSolicitudesStatesApproval =
      await api.GET_SIGN_SOLICITUDE_HISTORY.getSignSolicitudeHistory(
        idSolicitude,
      );
    if (responseGetSignSolicitudesStatesApproval !== null) {
      solicitudesSignApprovalHistory.current =
        responseGetSignSolicitudesStatesApproval;
    } else {
      showMsg(
        toast,
        "error",
        "Error",
        "Error capturando datos de firma historia de la solicitud",
      );
    }
  };

  const getPptoDisponibleValida = async (
    idCentroCosto: number,
    idItem: number,
    numeroLinea: number,
    mesGastoId: number,
  ) => {
    //ESTE DE PPTO PUEDE SER MIGRADO A CONTEXT EN UN SOLO LLAMADO PARA TODAS LAS CUENTAS Y SU PRESUPUESTO POR CENTRO
    const responseGetPptoDisponible =
      await api.GET_PPTO_DISPONIBLE_CC.getPptoCentroCosto(
        initData.id,
        idCentroCosto,
        idItem,
      );
    if (responseGetPptoDisponible !== null) {
      console.log(
        "PPTO DISPONIBLE: ",
        JSON.stringify(responseGetPptoDisponible),
      );
    } else {
      return "error";
    }

    const responseGetPptoSolicitadoCentro =
      await api.GET_PPTO_SOLICITADO_CC.getPptoDisponibleCentroCosto(
        initData.id,
        idCentroCosto,
        mesGastoId,
        idItem,
      );

    if (responseGetPptoSolicitadoCentro !== null) {
      console.log(
        "PPTO SOLICITADO: ",
        JSON.stringify(responseGetPptoSolicitadoCentro),
      );

      let sumPresupuestoDisponibleCentro = 0;
      for (var x = 1; x <= mesGastoId; x++) {
        switch (x) {
          case 1:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.enero;
            break;
          case 2:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.febrero;
            break;
          case 3:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.marzo;
            break;
          case 4:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.abril;
            break;
          case 5:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.mayo;
            break;
          case 6:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.junio;
            break;
          case 7:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.julio;
            break;
          case 8:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.agosto;
            break;
          case 9:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.septiembre;
            break;
          case 10:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.octubre;
            break;
          case 11:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.noviembre;
            break;
          case 12:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.diciembre;
            break;
          default:
        }
      }

      let totalValueLine =
        (
          document.getElementById(`os_precio_unitario_total_0`)
            ?.children[0] as HTMLInputElement
        )?.value ?? "0";

      let errorElement = document.getElementById(
        `ppto_error_${numeroLinea}`,
      ) as HTMLInputElement;

      let presupuestoSolicitadoTotalCc =
        responseGetPptoSolicitadoCentro.total +
        parseNumberCommaFormatForOperations(totalValueLine);

      console.log(
        "CHECK sumPresupuestoDisponibleCentro: ",
        sumPresupuestoDisponibleCentro,
      );
      console.log(
        "CHECK presupuestoSolicitadoTotalCc: ",
        presupuestoSolicitadoTotalCc,
      );
      //VALIDACIONES DE RETORNO
      if (sumPresupuestoDisponibleCentro < presupuestoSolicitadoTotalCc) {
        errorElement.innerText = "Sobrepasa el presupuesto disponible";
        return "#ff6767";
      }

      if (
        sumPresupuestoDisponibleCentro > presupuestoSolicitadoTotalCc &&
        presupuestoSolicitadoTotalCc >
          (sumPresupuestoDisponibleCentro * 90) / 100
      ) {
        errorElement.style.color = "#cdca6d";
        errorElement.innerText = "Has superado el 90% del presupuesto";
        return "yellow";
      } else {
        errorElement.style.color = "#000000";
        errorElement.innerText = "Presupuesto disponible";
        return "#FFFFFF";
      }
    } else {
      return "error";
    }
  };

  //**************************** VARIABLES Y ESTADOS *******************************/
  const [data, setData] = useState<any>([]);
  const [expandedRows, setExpandedRows] = useState<
    DataTableExpandedRows[] | undefined
  >(undefined);
  interface RowData {
    socdet_id: string;
    socdet_cantidad?: string;
    sdetcc_id?: number;
    sdetcc_nombre?: string;
    item_id?: number;
    item_nombre?: string;
    prov_id?: number;
    prov_nombre?: string;
    socdet_precio_unitario_ref?: string;
    socdet_precio_total_ref?: string;
    socdet_observaciones?: string;
    archivos?: string;
    socest_id?: number;
    socest_nombre?: string;
    sdetcc2_id?: number;
    sdetcc2_nombre?: string;
    oc_id?: number;
  }

  const [selectedRow, setSelectedRow] = useState<RowData | null>(null);
  const [selectedCentroCostoId, setSelectedCentroCostoId] = useState<number>(
    selectedRow?.sdetcc2_id ? selectedRow?.sdetcc2_id : 0,
  );
  const [selectedCentroCosto, setSelectedCentroCosto] = useState<string>(
    selectedRow?.sdetcc2_nombre ? selectedRow?.sdetcc2_nombre : "Seleccione...",
  );

  const [jsonDataEditDetalle, setJsonDataEditDetalle] = useState({});
  const [metaKey, setMetaKey] = useState(true);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogPdfVisible, setDialogPdfVisible] = useState(false);
  const [dialogEditaDetalleVisible, setDialogEditaDetalleVisible] =
    useState(false);
  const [dialogEditaEstadoSol, setDialogEditaEstadoSol] = useState(false);

  FilterService.register("custom_detail_proveedor_filter", (value, filter) => {
    // 1. If user hasn't typed anything, show everything
    if (!filter || filter.trim() === "") return true;

    // 2. 'value' is now correctly row.detalle
    if (!value || !Array.isArray(value)) return false;

    return value.some((item: any) => {
      // IMPORTANT: Verify 'prov_nombre' exists inside these objects
      const nombre = item.prov_nombre
        ? String(item.prov_nombre).toLowerCase()
        : "";
      return nombre.includes(filter.toLowerCase());
    });
  });

  FilterService.register("custom_detail_aprobador_filter", (value, filter) => {
    // 1. Si el usuario no ha escrito nada, mostramos todo
    if (!filter || filter.trim() === "") return true;

    // 2. 'value' aquí recibe directamente tu string "aprobadores_combinados"
    if (!value) return false;

    // 3. Simplemente verificamos si el texto ingresado está dentro del string de aprobadores
    return String(value).toLowerCase().includes(filter.toLowerCase());
  });

  const [filters, setFilters] = useState<{
    [key: string]: { value: string | null; matchMode: any };
  }>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    tipmon_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subdoc_nombre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    soc_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    busqueda_solicitante: { value: null, matchMode: FilterMatchMode.CONTAINS },
    cc_nombre: {
      value: searchParams.get("cc_nombre") || null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    soc_dt_cre: {
      value: searchParams.get("soc_dt_cre") || null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    socest_nombre: {
      value: searchParams.get("socest_nombre") || null,
      matchMode: FilterMatchMode.EQUALS,
    },
    oc_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    detalle: {
      value: null,
      matchMode: "custom_detail_proveedor_filter" as any,
    },
    aprobadores_combinados: {
      value: searchParams.get("aprobador") || null,
      matchMode: "custom_detail_aprobador_filter" as any,
    },
    // Filtro "Centro Costo Destino" (cabecera de la tabla)
    centros_costo_destino: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [isLoading, setIsLoading] = useState(true);
  // Hasta que llega la primera carga de datos se muestra "Cargando..." en
  // lugar de la tabla (isLoading se apaga apenas se renderiza)
  const [cargandoDatos, setCargandoDatos] = useState(true);
  // Same 20px on every side: the app shell is 100vw wide, so the
  // scrollbar width is added back on the right (--rp-scrollbar-width)
  useScrollbarGutter();
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const areaRef = useRef<HTMLTextAreaElement>(null);
  const toast = useRef(null);
  const dt = useRef<DataTable<typeof data> | null>(null);

  const getTiposEstado = (status: any) => {
    switch (status) {
      case "Anulada":
        return "var(--color-anuladas)";
      case "Aprobada":
        return "var(--color-aprobadas)";
      case "Pendiente":
        return "var(--color-pendiente)";
      case "Rechazada":
        return "var(--color-rechazadas)";
      case "Rechazada parcialmente":
        return "var(--color-rechazadas-parcial)";
      case "Aprobada parcialmente":
        return "var(--color-aprobadas-parcial)";
      case "Confirmada":
        return "var(--color-confirmadas)";
      case "Confirmada parcialmente":
        return "var(--color-confirmadas-parcial)";
      case "Emitida":
        return "var(--color-emitidas)";
      case "Pendiente GG":
        return "var(--color-pendientes-gte)"; // Corregido: plural según tus CSS comments
      case "Confirmadas GG":
        return "var(--color-confirmadas-gte)";
      default:
        return "var(--primary-color)"; // Color por defecto (gris o primario)
    }
  };

  const [editDetalleDialog, setEditDetalleDialog] = useState(false);
  const [deleteDetalleDialog, setDeleteDetalleDialog] = useState(false);
  const [showDialogDownloadFiles, setShowDialogDownloadFiles] = useState(false);
  const ref = useRef<any>(null);
  const [showModalFirma, setShowModalFirma] = useState(false);
  //ESTADOS DE NUEVO DETALLE A CREAR
  const [submittedNewDetail, setSubmittedNewDetail] = useState(false);
  const [newDetailDialog, setNewDetailDialog] = useState(false);
  const [newDetalle, setNewDetalle] = useState(emptyNewDetalle);
  const [deleteNewDetailDialog, setDeleteNewDetailDialog] = useState(false);
  const [deleteNewDetailsDialog, setDeleteNewDetailsDialog] = useState(false);
  const [showModalConfirmNewDetail, setShowModalConfirmNewDetail] =
    useState(false);
  const lastPriceItemSelected = useRef<any[]>([]);

  useEffect(() => {
    if (data.length || needFetchingSoc) return;
    setNeedFetchingSoc(true);
  }, [data]);

  const hideNewDialog = () => {
    setSubmittedNewDetail(false);
    setNewDetailDialog(false);
  };

  /******************************** CRUD DE DETALLES SOLICITUDES ******************************/

  const hideEditDetalleDialog = () => {
    //setSubmitted(false);
    setEditDetalleDialog(false);
  };

  /*const editProduct = (product) => {
        setProduct({ ...product });
        setProductDialog(true);
    };

    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    };

    const deleteProduct = () => {
        let _products = products.filter((val) => val.id !== product.id);

        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
    };*/

  //*******************************************************************************************/

  /******************************** EXPORT DOCUMENTS *********************************/

  {
    /* const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));*/
  }

  const exportCSV = (selectionOnly: any) => {
    if (dt.current) {
      dt.current.exportCSV({ selectionOnly });
    }
  };

  /*const exportPdf = () => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                (doc as any).autoTable({
                    head: [exportColumns.map(col => col.title)],
                    body: data.map(item => exportColumns.map(col => item.detalle[col.dataKey])),
                });
                doc.save('products.pdf');
            });
        });
    };*/

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Generate date string DDMMYYYY
      const today = new Date().toLocaleDateString("es-ES").split("/").join("");

      // 1. HEADERS (Cabecera)
      const dataConAlias = data.map((item: any) => ({
        "N° Solicitud": item.soc_id,
        "Estado Actual": item.socest_nombre,
        "Fecha Creación": item.soc_dt_cre,
        "Tipo Solicitud": item.subdoc_nombre,
        Solicitante: item.nombres, // Added quotes for consistency
        "Centro solicitante": item.cc_nombre,
        "Tipo moneda": item.tipmon_nombre,
        "Estado Oper.": item.estope_nombre,
        "Mes Presupuesto": item.meses_nombre,
      }));

      const worksheet = xlsx.utils.json_to_sheet(dataConAlias);

      // 2. DETAILS (Detalles)
      const detallesConAlias = data
        .flatMap((item: any) => item.detalle || [])
        .map((det: any) => ({
          "N° Detalle": det.socdet_id,
          "N° Solicitud": det.socdet_id_solicitud_orden_compra,
          "N° OC Asociada": det.oc_id,
          Proveedor: det.prov_nombre, // Added quotes
          "Producto/Servicio": det.item_nombre,
          "Centro Costo": det.sdetcc2_nombre,
          Cantidad: det.socdet_cantidad, // Added quotes
          "Precio Unitario Ref.": det.socdet_precio_unitario_ref,
          "Precio Total Ref.": det.socdet_precio_total_ref,
          Estado: det.socest_nombre, // Added quotes
          Glosa: det.socdet_observaciones, // Added quotes
          Aprobador: det.suda_nombre_usuario, // Added quotes
          Justificaciones: det.justificacion, // Added quotes
          "Fecha creación": det.socdet_dt_cre,
        }));

      const worksheetDetail = xlsx.utils.json_to_sheet(detallesConAlias);

      // 3. WORKBOOK GENERATION
      // IMPORTANT: Keys here must match the strings in SheetNames
      const workbook = {
        Sheets: {
          "Cabecera SOC": worksheet,
          "Detalles SOC": worksheetDetail,
        },
        SheetNames: ["Cabecera SOC", "Detalles SOC"],
        Props: {},
      };

      // 4. WRITE FILE
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array", // Best for React/Browser environment
      });

      saveAsExcelFile(excelBuffer, `Solicitudes_Compra_${today}`);
    });
  };

  /* const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);

      const worksheetDetail = xlsx.utils.json_to_sheet(
        data.flatMap((item: any) => item.detalle || []),
      );

      const workbook = {
        Sheets: { data: worksheet, detalle: worksheetDetail },
        SheetNames: ["data", "detalle"],
        Props: {},
      };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };*/

  const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
      }
    });
  };

  /************************************************************************************/
  /*************************** EVENTOS FUNCIONES *************************/

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  // Filtro "Centro Costo Destino": centros de costo de las lineas de detalle
  const onCentroCostoDestinoChange = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      centros_costo_destino: {
        value: value.trim() ? value : null,
        matchMode: FilterMatchMode.CONTAINS,
      },
    }));
  };

  const onFilterChange = (e: any) => {
    // 1. Actualiza el estado visual de la tabla
    setFilters(e.filters);

    // 2. Extrae el nuevo valor que el usuario seleccionó para el estado
    const newSocestValue = e.filters.socest_nombre?.value;

    // 3. Clona los parámetros actuales de la URL para no sobreescribir otros si los tuvieras
    const currentParams = new URLSearchParams(searchParams);

    // 4. Actualiza o elimina el parámetro en la URL
    if (newSocestValue) {
      currentParams.set("socest_nombre", newSocestValue);
    } else {
      currentParams.delete("socest_nombre");
    }

    // 5. Empuja la nueva URL al navegador
    setSearchParams(currentParams);
  };

  /********************************* TEMPLATES DE CELDAS *************************************/

  const singleFilterSolicCentroElement = (
    options: ColumnFilterElementTemplateOptions,
  ) => {
    return (
      <div className="flex flex-column gap-2">
        <InputText
          placeholder="Solicitante..."
          value={options.value || ""}
          // 👇 CAMBIO AQUÍ: Usar filterApplyCallback
          onChange={(e) => options.filterApplyCallback(e.target.value)}
        />
      </div>
    );
  };

  const filtroNombreOCentro = (
    value: any,
    filter: any,
    filterLocale: string,
    params: any,
  ) => {
    if (!filter) return true;

    const textoBusqueda = String(filter).toLowerCase();
    const fila = params?.rowData;

    if (!fila) return false;

    // 👇 Unimos el nombre y el apellido paterno
    const nombreCompleto =
      `${fila.nombres || ""} ${fila.apellidos || ""}`.toLowerCase();
    const coincideNombre = nombreCompleto.includes(textoBusqueda);

    const coincideCentro = String(fila.cc_nombre || "")
      .toLowerCase()
      .includes(textoBusqueda);

    return coincideNombre || coincideCentro;
  };

  const solicitanteFusionadoBodyTemplate = (rowData: any) => {
    // 1. Unimos el nombre y el apellido de forma segura (por si alguno viene nulo)
    const nombreCompleto =
      `${rowData.nombres || ""} ${rowData.apellidos || ""}`.trim();

    return (
      <div className="flex align-items-center gap-2">
        <img
          alt="solicitante"
          src={Avatar}
          style={{ width: "24px", height: "24px", paddingRight: "5px" }}
        />
        {/* 2. Mostramos el nombre completo arriba y el centro abajo */}
        <div className="flex flex-column">
          <div>
            <span className="font-bold">{nombreCompleto}</span>
          </div>
          <div>
            <span
              style={{
                fontSize: "0.6rem",
                fontWeight: 800,
              }}
              className="text-sm text-500"
            >
              {rowData.cc_nombre}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const singleFilterAprobadorElement = (
    options: ColumnFilterElementTemplateOptions,
  ) => {
    return (
      <div className="flex flex-column gap-2">
        <InputText
          placeholder="Aprobador..."
          value={options.value || ""}
          // 👇 CAMBIO AQUÍ: Usar filterApplyCallback
          onChange={(e) => options.filterApplyCallback(e.target.value)}
        />
      </div>
    );
  };

  const filtroAprobador = (
    value: any,
    filter: any,
    filterLocale: string,
    params: any,
  ) => {
    if (!filter) return true;

    const textoBusqueda = String(filter).toLowerCase();
    const fila = params?.rowData;

    if (!fila) return false;

    // 👇 Unimos el nombre y el apellido paterno
    const nombreCompleto = `${fila.suda_nombre_usuario || ""}`.toLowerCase();
    const coincideAprobador = nombreCompleto.includes(textoBusqueda);

    return coincideAprobador;
  };

  const aprobadorBodyTemplate = (rowData: any) => {
    let usuarioAprobador = "";

    const aprobadores = rowData.detalle
      ? rowData.detalle
          .map((d: any) => d.suda_nombre_usuario) // Extraemos los nombres
          .filter(
            (nombre: string, index: number, self: string[]) =>
              nombre && self.indexOf(nombre) === index, // Filtramos duplicados y vacíos
          )
      : [];
    // 1. Unimos el nombre y el apellido de forma segura (por si alguno viene nulo)
    const nombreCompleto = `${aprobadores || ""}`.trim();

    return (
      <div className="flex align-items-center gap-2">
        <img
          alt="aprobador"
          src={Avatar}
          style={{ height: "24px", paddingRight: "5px" }}
        />
        {/* 2. Mostramos el nombre completo arriba y el centro abajo */}
        <div className="flex flex-column">
          <div>
            <span className="font-bold">{nombreCompleto}</span>
          </div>
        </div>
      </div>
    );
  };

  const mainProveedorTemplate = (rowData: any) => {
    const provs = rowData.detalle?.map((d: any) => d.prov_nombre);
    const uniqueProvs = [...new Set(provs)] as string[];

    if (uniqueProvs.length === 0) return <span>Sin proveedores</span>;
    if (uniqueProvs.length === 1) return <span>{uniqueProvs[0]}</span>;

    return (
      <span>
        {uniqueProvs[0]} (+{uniqueProvs.length - 1})
      </span>
    );
  };

  useEffect(() => {
    setIsLoading(false);
  });

  const archivoBodyTemplate = (data: any) => {
    const parts = data.soc_dt_cre.split("-");
    const mes = parts[1];
    const ano = parts[2];

    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Button
          label={`SUBIR ANEXOS ↑`}
          className="btnArchivoDialog"
          onClick={() => setDialogVisible(true)}
        />
        <DownloadFiles
          path={`solicitudes/${ano}/${mes}/${data.soc_id}`}
          numDoc={data.soc_id}
          className="btnArchivoDialog"
          pdf={false}
        />
      </div>
    );
  };

  //************************ ESTADO FUNCIONES FILTRO *********************/
  const estadoBodyTemplateSelected = (option: any) => {
    return (
      <Tag
        className="tagTable"
        value={option} // Aquí es option directo, no option.ocest_nombre
        style={{
          backgroundColor: getTiposEstado(option),
          color: "white", // Opcional: para asegurar que el texto se lea bien
        }}
      />
    );
  };

  const estadoBodyTemplate = (option: any) => {
    return (
      <div>
        <Tag
          className="tagTable"
          value={option.socest_nombre}
          style={{
            backgroundColor: getTiposEstado(option.socest_nombre),
            color: "white", // Opcional
          }}
          onClick={() => {
            //setDialogEditaEstadoOc(true);
          }}
        />
        <p style={{ color: "var(--primary-dark-color)" }}>
          {option.justificacion}
        </p>
      </div>
    );
  };

  const estadoRowFilterTemplate = (
    options: ColumnFilterElementTemplateOptions,
  ) => {
    const uniqueEstados = Array.from(
      new Set(data.map((item: { socest_nombre: any }) => item.socest_nombre)),
    );
    return (
      <Dropdown
        value={options.value}
        options={uniqueEstados}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={estadoBodyTemplateSelected}
        placeholder="Sel."
        className="p-column-filter"
        showClear
        style={{
          marginLeft: "0",
          maxWidth: "6rem",
          marginBottom: "1rem",
          height: "2.5rem",
          width: "10rem",
        }}
      />
    );
  };

  /****************************** DIALOG MODAL ***************************/

  const dialogFooterTemplate = () => {
    return (
      <Button
        style={{ backgroundColor: "blue", width: "50px", height: "30px" }}
        label="Ok"
        onClick={() => {
          setDialogVisible(false);
          setDialogPdfVisible(false);
        }}
      />
    );
  };

  const handleQuantityChange = (value: number, index: number) => {
    const totalPrecioUni = value * selectedPrecioUnitarioRef;
    setSelectedPrecioTotalRef(totalPrecioUni);
  };

  const fetchLastPriceItemSelected = async (
    idItemSelected: number,
    idRow: number,
  ) => {
    //SE PUEDE INCORPORAR AVISO DE EXISTENCIA

    try {
      const responseGetLastPriceItem =
        await api.GET_LAST_PRICE_ITEM_SELECTED.getLastPriceItemSelected(
          idItemSelected,
        );
      if (responseGetLastPriceItem !== null) {
        console.log(responseGetLastPriceItem);
        lastPriceItemSelected.current[idRow] =
          responseGetLastPriceItem.ultimo_precio_unitario_neto;

        setselectedPrecioUnitarioRef(
          responseGetLastPriceItem.ultimo_precio_unitario_neto,
        );

        console.log("Last Price Item Selected:", responseGetLastPriceItem);

        const cantidadElement = document.getElementById(`os_cantidad_${idRow}`)
          ?.childNodes[0] as HTMLFormElement;

        let cleanValue = cantidadElement.value
          .replace(/\./g, "")
          .replace(",", ".");

        let quantityRow = parseFloat(cleanValue);

        setSelectedPrecioTotalRef(
          responseGetLastPriceItem.ultimo_precio_unitario_neto * quantityRow,
        );
      }
    } catch (error) {
      setselectedPrecioUnitarioRef(0);
      setSelectedPrecioTotalRef(0);
      console.error("Error fetching last price item:", error);
    }
  };
  /***********************************************************************/

  /******************************* ROW EXPANSION PARA DETALLES DE SOLICITUD ************************/

  const onRowExpand = (event: any) => {
    /*const dataEdit = event.data;
    setSelectedMesGasto(dataEdit.meses_nombre);
    setSelectedMesGastoId(dataEdit.meses_id);
    setSelectedEStadoOp(dataEdit.estope_nombre);
    setSelectedEstadoOpId(dataEdit.estope_id);
    setSelectedTipoMoneda(dataEdit.tipmon_nombre);
    setSelectedTipoMonedaId(dataEdit.tipmon_id);
    setSelectedTipoSolicitud(dataEdit.subdoc_nombre);
    setSelectedTipoSolicitudId(dataEdit.subdoc_id);
    setSelectedNumeroSolicitud(dataEdit.soc_id);
    setSelectedDetailRowId(dataEdit.socdet_id);
    setSelectedEstado(dataEdit.socest_nombre);
    setSelectedEstadoId(dataEdit.socest_id);*/
  };

  const toggleRow = (rowData: any) => {
    const isCurrentRowExpanded = expandedRows
      ? expandedRows[rowData.soc_id]
      : false;

    if (isCurrentRowExpanded) {
      //SE CIERRA EN EL EVENTO DE TOGGLE DE FILA EXPANDIDA
      let _expandedRows: any = {};
      _expandedRows[`${rowData.soc_id}`] = undefined;
      setExpandedRows(_expandedRows);
    } else {
      //SE ABRE EN EL EVENTO DE TOGGLE DE FILA CERRADA Y SE CIERRAN LAS OTRAS QUE PUEDAN ESTAR ABIERTAS
      let _expandedRows: any = {};

      data.forEach((p: any) => {
        if (p.detalle.length > 0 && p.soc_id === rowData.soc_id) {
          _expandedRows[`${p.soc_id}`] = true;
        } else {
          _expandedRows[`${p.soc_id}`] = undefined;
        }
      });
      setExpandedRows(_expandedRows);
    }
  };

  const togglerTemplate = (rowData: any) => {
    // Check if THIS specific row is expanded to determine the icon
    const isExpanded = expandedRows ? expandedRows[rowData.soc_id] : false;

    return (
      <Button
        style={{ width: "2rem", height: "2rem" }}
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className="p-button-text p-button-rounded p-button-plain"
        onClick={() => toggleRow(rowData)}
        aria-label={isExpanded ? "Collapse Row" : "Expand Row"}
      />
    );
  };

  const onRowCollapse = (event: any) => {
    if (toast.current) {
      //toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    }
  };

  const expandAll = () => {
    let _expandedRows: any = {};

    data.forEach((p: any) => {
      if (p.detalle.length > 0) {
        _expandedRows[`${p.soc_id}`] = true;
      }
    });

    setExpandedRows(_expandedRows);
  };

  const collapseAll = () => {
    setExpandedRows(undefined);
  };

  const allowExpansion = (rowData: any) => {
    return rowData[0].detalle.length > 0;
  };

  /**** SECCION DE FUNCIONES DE ACTUALIZACION DE DROPDOWNS SEGUN SELECCION *******/

  const handleUpdateMesFromChild = (option: any) => {
    setSelectedMesGasto(option.nombre);
    setSelectedMesGastoId(option.id);
  };
  const handleUpdateCentroFromChild = (option: any) => {
    setSelectedCentroCosto(option.nombre);
    setSelectedCentroCostoId(option.id);
  };

  const handleUpdateItemFromChild = (option: any) => {
    setSelectedItem(option.nombre ?? "");
    setSelectedItemId(option.id ?? 0);

    fetchLastPriceItemSelected(option.id, 0);
  };

  const handleUpdateProveedorFromChild = (option: any) => {
    setSelectedProveedor(option.nombre);
    setSelectedProveedorId(option.id);
  };

  const handleUpdateEstadoFromChild = (option: any) => {
    setSelectedEstado(option.nombre);
    setSelectedEstadoId(option.id);
  };

  const handlePrecioUnitarioChange = (value: number, index: number) => {
    const totalPrecioUni = selectedCantidad * value;
    setSelectedPrecioTotalRef(totalPrecioUni);
  };

  const handleUpdateTipoMonFromChild = (option: any) => {
    setSelectedTipoMoneda(option.nombre);
    setSelectedTipoMonedaId(option.id);
  };

  const handleUpdateEstadoOpeFromChild = (option: any) => {
    setSelectedEStadoOp(option.nombre);
    setSelectedEstadoOpId(option.id);
  };

  const handleUpdateTipoSolFromChild = (option: any) => {
    setSelectedTipoSolicitud(option.nombre);
    setSelectedTipoSolicitudId(option.id);

    itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
      itemsAdquisicion,
      option.id,
      tiposItemsAdquisicion,
    );
  };

  const handleUpdateAprobadoresFromChild = (option: any) => {
    setSelectedAprobador(option.nombre);
    setSelectedAprobadorId(option.id);
  };

  const saveSolicitudEdition = () => {
    const jsonObj: any = {
      id: selectedNumeroSolicitud,
      tiposolicitud: selectedTipoSolicitudId,
      mesgasto: selectedMesGastoId,
      estadooperacional: selectedEstadoOpId,
      tipomoneda: selectedTipoMonedaId,
      idusuariosolicitante: initData.id,
      estadosolicitud: 1,
      detalles: [],
    };

    let detallesDivText = document.getElementById("os_detalles_0")?.innerHTML;

    if (
      selectedTipoSolicitudId === 0 ||
      selectedMesGastoId === 0 ||
      selectedEstadoOpId === 0 ||
      selectedTipoMonedaId === 0
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Deben ser seleccionados todos los datos de cabecera de la solicitud",
      );
    } else {
      const precioUnitario = document.getElementById(`os_precio_unitario_0`)
        ?.childNodes[0] as HTMLFormElement;

      const precioUnitarioTotal = document.getElementById(
        `os_precio_unitario_total_0`,
      )?.childNodes[0] as HTMLFormElement;

      const aprobadorUsuarioId =
        aprobadoresFull.find(
          (aprobador) => aprobador.id === selectedAprobadorId,
        )?.id_usuario ?? 0;

      const jsonDetalleObj: any = {
        id: selectedDetailRowId,
        idsolicitudoc: selectedNumeroSolicitud,
        cantidad: selectedCantidad.toString(),
        item: selectedItemId,
        centrocosto: selectedCentroCostoId,
        proveedor: selectedProveedorId,
        preciorefunitario: precioUnitario.value,
        preciorefunitariototal: precioUnitarioTotal.value,
        detalles: (detallesDivText ?? selectedDetalles.current) || "",
        aprobador: aprobadorUsuarioId,
      };

      jsonObj.detalles.push(jsonDetalleObj);

      //CAPTURA ESPECIAL DE ULTIMA FILA PARA VALIDAR ANTES DE REGISTRAR
      if (selectedCantidad == 0) {
        showMsg(toast, "warn", "Advertencia", "Debe ingresar una cantidad");
      } else if (selectedItem == "") {
        showMsg(toast, "warn", "Advertencia", "Debe ingresar un item");
      } else if (selectedCentroCosto == "") {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un centro de costo",
        );
      } else if (selectedProveedor == "") {
        showMsg(toast, "warn", "Advertencia", "Debe ingresar un proveedor");
      } else if (selectedPrecioUnitarioRef == 0) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un precio unitario",
        );
      } else if (selectedPrecioTotalRef == 0) {
        showMsg(toast, "warn", "Advertencia", "El total debe ser mayor a 0 ");
      } else if ((detallesDivText?.length ?? 0) < 5) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar detalles adicionales",
        );
      } else if (selectedAprobadorId === 0) {
        showMsg(toast, "warn", "Advertencia", "Debe seleccionar un aprobador");
      } else {
        setShowModalConfirm(true);
        setJsonDataSolicitud(jsonObj);
      }
    }
  };

  const formatCurrency = (value: any, tipmonId?: number) => {
    const decimals = tipmonId === 1 ? 0 : 2;

    return (Number(value) || 0).toLocaleString("de-DE", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  };

  const precioTotalTemplate = (rowData: any) => {
    return formatCurrency(rowData.soc_precio_total_ref);
  };

  const precioUniBodyTemplate = (rowData: any) => {
    return formatCurrency(rowData.socdet_precio_unitario_ref);
  };
  const precioTotBodyTemplate = (rowData: any) => {
    return formatCurrency(rowData.socdet_precio_total_ref);
  };

  const handleUpdateJustificacion = (e: any) => {
    selectedJustificacion.current =
      selectedJustificacion.current + e.target.innerHTML;
  };

  const sendNewApprovalStateSolicitude = async (dataSolicitud: any) => {
    const justificacionText =
      document.getElementById("os_justificacion")?.innerHTML;
    const idDetalle = selectedRow?.socdet_id;

    const objApprovalState = {
      id_solicitud_orden_compra: dataSolicitud.soc_id,
      id_solicitud_orden_compra_detalle: idDetalle,
      id_solicitud_oc_estado: selectedEstadoId,
      id_usuario_aprobador: initData.id,
      justificacion: justificacionText,
      dt_cre: new Date(),
      dt_mod: new Date(),
    };

    if (selectedEstadoId == 0) {
      showMsg(toast, "warn", "Advertencia", "Debe seleccionar el estado");
    } else if (
      (selectedEstadoId == 4 || selectedEstadoId == 2) &&
      (justificacionText?.length ?? 0) < 4
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe ingresar justificaciones al seleccionar estado de rechazo o anulación",
      );

      setShowModalLoadSpinner(false);
    } else if (
      (selectedEstadoId == 4 || selectedEstadoId == 2) &&
      !VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT(justificacionText)
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Solo puedes ingresar en la justificación: letras, números, puntos, comas, guión o guión bajo, no se permiten espacios al final ni saltos de línea con enter.",
      );

      return;
    } else {
      const responseSaveNewStateSolicitude =
        await api.POST_SOLICITUDE_APPROVAL_STATE.sendSolicitudeApprovalState(
          Number(idDetalle),
          JSON.stringify(objApprovalState),
        );
      if (responseSaveNewStateSolicitude !== null) {
        //REGISTRAMOS HISTORIAL DE APROBACION DE FIRMA CON NUEVO CODIGO VALIDADOR

        let objApprovalSignHis = {
          id_usuario: initData.id,
          id_solicitud_oc: dataSolicitud.soc_id,
          id_solicitud_aprobacion_his: responseSaveNewStateSolicitude.id,
          id_algoritmo: self.crypto.randomUUID().toString().substring(0, 15),
          id_algoritmo_dos: "",
          dt_cre: new Date(),
        };

        const responseSaveNewSignHisApprovalSolicitude =
          await api.SEND_NEW_APPROVAL_SIGN_HIS_SOLICITUDE.sendNewApprovalSignHisSolicitude(
            JSON.stringify(objApprovalSignHis),
          );

        //ENVIAMOS MAIL DE NOTIFICACION DE INGRESO DE SOLICITUD DE ORDEN DE COMPRA
        const responseEmailsDestinatarios =
          await api.GET_EMAILS_DESTINATARIES_SOL.getEmailsDestinatariesSol(
            dataSolicitud.soc_id,
            Number(idDetalle),
            selectedEstadoId == 6
              ? "APROBACION"
              : selectedEstadoId == 8
                ? "CONFIRMACION"
                : selectedEstadoId == 10
                  ? "CONFIRMACION"
                  : selectedEstadoId == 4
                    ? contextmenu == "aprueba"
                      ? "APROBACION"
                      : contextmenu == "confirma"
                        ? "CONFIRMACION"
                        : "CREACION"
                    : "CREACION",
          );

        responseEmailsDestinatarios.push(initData.email);

        if (
          responseSaveNewSignHisApprovalSolicitude !== null &&
          responseEmailsDestinatarios.length > 0
        ) {
          //CREACION INCLUYE NUEVA SOLICITUD, NUEVO DETALLE Y EDICION DETALLE , REMITE A:

          if (appEnv === "production") {
            //ENVIAMOS MAIL DE NOTIFICACION DE CAMBIO DE ESTADO DE SOLICITUD DE ORDEN DE COMPRA

            //SOLO SE NOTIFICAN RECHAZOS DESDE 10-03-2026
            let paramApruebaSocNt = parametros.find(
              (param: { codigo: string }) => param.codigo === "APRSOCNT",
            )?.valor;

            if (paramApruebaSocNt == 0) {
              if (selectedEstadoId == 4) {
                let objMailUpdateSolicitudeState = {
                  from: "noreply@salmonesdechile.com",
                  subjectEmail: `Se ha actualizado la solicitud de orden de compra N° ${dataSolicitud.soc_id} en su detalle N° ${idDetalle}, con el estado: ${selectedEstado}`,
                  sendTo: responseEmailsDestinatarios.join(","),
                  template: "nuevoEstadoSolicitudCompra",
                  nroSolicitud: dataSolicitud.soc_id,
                  usuario:
                    initData.nombres !== undefined
                      ? initData.nombres + " " + initData.apellido_paterno
                      : "solicitante sin nombres",
                  centroCosto: selectedRow?.sdetcc2_nombre,
                  estado: selectedEstado,
                  nroDetalle: idDetalle,
                };
                await api.POST_SEND_EMAIL_NOTIFICATION.sendNewEmail(
                  JSON.stringify(objMailUpdateSolicitudeState),
                );
              }
            }
          }
          setShowModalLoadSpinner(false);

          showMsg(toast, "success", "Éxito", "Estado registrado exitosamente");
          setDialogEditaEstadoSol(false);
          setNeedFetchingSoc(true);
        } else {
          showMsg(
            toast,
            "error",
            "Error",
            "Ocurrió un error registrando el nuevo estado del detalle de solicitud",
          );
          setShowModalLoadSpinner(false);
          setDialogEditaEstadoSol(false);
        }
      }
    }
  };
  /*******************************************************************************/
  // SECCION DE NUEVO DETALLE
  const addNewDetail = (data: any) => {
    if (data.socest_id > 6) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No se pueden agregar detalles a una solicitud con confirmaciones",
      );
      return;
    }

    if (contextmenu == "aprueba" || contextmenu == "confirma") {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No está permitido agregar detalles sobre una solicitud de terceros",
      );
    }

    if (
      initData.roles.some(
        (role: { codigo: string }) => role.codigo === "MANSOC",
      ) &&
      data.user_id === initData.id &&
      contextmenu == "mantiene"
    ) {
      setNewDetalle(emptyNewDetalle);
      setSelectedNumeroSolicitud(data.soc_id);
      //EL EMPTY DETALLE PASA POR SETEAR LOS ESTADOS QUE TAMBIEN SON OCUPADOS EN LA EDICION
      setSelectedMesGasto("");
      setSelectedMesGastoId(0);
      setSelectedEStadoOp("");
      setSelectedEstadoOpId(0);
      setSelectedTipoMoneda("");
      setSelectedTipoMonedaId(0);
      setSelectedTipoSolicitud("");
      setSelectedTipoSolicitudId(0);
      setSelectedEstado("");
      setSelectedEstadoId(0);
      setSelectedCantidad(0);
      setSelectedCentroCosto("");
      setSelectedCentroCostoId(0);
      setSelectedProveedor("");
      setSelectedProveedorId(0);
      setSelectedItem("");
      //setSelectedItemId(0);
      setSelectedItemId(0);
      setSelectedEstado("");
      setSelectedEstadoId(0);
      setselectedPrecioUnitarioRef(0);
      setSelectedPrecioTotalRef(0);
      selectedDetalles.current = "";
      setSelectedAprobador("");
      setSelectedAprobadorId(0);
      setSubmittedNewDetail(false);
      setNewDetailDialog(true);
    } else {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "No puedes agregar detalles a solicitudes que no has creado.",
      );
    }
  };

  const saveNewDetail = () => {
    setSubmittedNewDetail(true);

    let detallesDivText = document.getElementById("os_detalles_0")?.innerHTML;

    const precioUnitario = document.getElementById(`os_precio_unitario_0`)
      ?.childNodes[0] as HTMLFormElement;

    const precioUnitarioTotal = document.getElementById(
      `os_precio_unitario_total_0`,
    )?.childNodes[0] as HTMLFormElement;

    const aprobadorUsuarioId =
      aprobadoresFull.find((aprobador) => aprobador.id === selectedAprobadorId)
        ?.id_usuario ?? 0;

    const jsonDetalleObj: any = {
      idsolicitudoc: selectedNumeroSolicitud,
      cantidad: selectedCantidad.toString(),
      item: selectedItemId,
      centrocosto: selectedCentroCostoId,
      proveedor: selectedProveedorId,
      preciorefunitario: precioUnitario.value,
      preciorefunitariototal: precioUnitarioTotal.value,
      aprobador: aprobadorUsuarioId,
      detalles: (detallesDivText ?? selectedDetalles.current) || "",
    };
    //CAPTURA ESPECIAL DE ULTIMA FILA PARA VALIDAR ANTES DE REGISTRAR

    if (selectedCantidad == 0) {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar una cantidad");
    } else if (selectedItem == "") {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un item");
    } else if (selectedCentroCosto == "") {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un centro de costo");
    } else if (selectedProveedor == "") {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un proveedor");
    } else if (selectedPrecioUnitarioRef == 0) {
      showMsg(toast, "warn", "Advertencia", "Debe ingresar un precio unitario");
    } else if (selectedPrecioTotalRef == 0) {
      showMsg(toast, "warn", "Advertencia", "El total debe ser mayor a 0 ");
    } else if ((detallesDivText?.length ?? 0) < 5) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe ingresar detalles adicionales",
      );
    } else if (!VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT(detallesDivText)) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Solo puedes ingresar en los detalles adicionales (glosas) letras, números, puntos, comas, guión o guión bajo, paréntesis, slash no se permiten espacios al final ni saltos de línea con enter.",
      );
    } else if (selectedAprobadorId === 0) {
      showMsg(toast, "warn", "Advertencia", "Debe seleccionar un aprobador");
    } else {
      setJsonDataSolicitud(jsonDetalleObj);
      setShowModalConfirmNewDetail(true);
    }
  };

  const hideDeleteDetailDialog = () => {
    setDeleteNewDetailDialog(false);
  };

  const hideDeleteDetailsDialog = () => {
    setDeleteNewDetailsDialog(false);
  };

  const deleteDetail = () => {
    /* let _products = products.filter((val) => val.id !== product.id);

        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });*/
    console.log("Eliminando detalle");
  };

  const newDetailtDialogFooter = (
    <>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={hideNewDialog}
      />
      <Button label="Save" icon="pi pi-check" onClick={saveNewDetail} />
    </>
  );
  const deleteDetailDialogFooter = (
    <>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteDetailDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteDetail}
      />
    </>
  );

  //SECCION DE TODO EL DETALLE AL EXPANDIRSE
  const rowExpansionTemplate = (data: any) => {
    const parts = data.soc_dt_cre.split("-");
    const mes = parts[1];
    const ano = parts[2];
    // const ano = dateSoc.getFullYear();
    // const mes = dateSoc.getMonth() + 1;

    itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
      itemsAdquisicion,
      data.subdoc_id,
      tiposItemsAdquisicion,
    );

    const textAreaRender = () => (
      <div
        contentEditable="true"
        suppressContentEditableWarning={true}
        style={{
          border: 1,
          borderStyle: "solid",
          width: "280px",
          height: "140px",
          padding: "20px",
        }}
        id="os_detalles_0"
        onError={() => alert("XSS detectado")}
        dangerouslySetInnerHTML={createMarkup()}
      ></div>
    );

    const sanitizedHtml = () => {
      // Ensure selectedDetalles.current is defined and handle both string or array-like values safely.
      const current = selectedDetalles.current ?? "";
      return DOMPurify.sanitize(current);
    };

    const createMarkup = () => {
      try {
        return { __html: sanitizedHtml() };
      } catch (error) {
        console.log("Error: ", error);
        return { __html: "" };
      }
    };

    const precioUniBodyTemplateLocal = (rowDetalle: any) => {
      return formatCurrency(
        rowDetalle.socdet_precio_unitario_ref,
        data.tipmon_id,
      );
    };

    const precioTotBodyTemplateLocal = (rowDetalle: any) => {
      return formatCurrency(rowDetalle.socdet_precio_total_ref, data.tipmon_id);
    };

    return (
      <div className="p-3">
        <Dialog
          visible={newDetailDialog}
          style={{ width: "50vw" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header={`Nuevo Detalle de Solicitud N° ${selectedNumeroSolicitud}`}
          modal
          maximizable
          className="p-fluid"
          onHide={hideNewDialog}
        >
          <div className="card flex justify-content-center">
            <div className="rowEditData" style={{ marginBottom: "0px" }}>
              <div
                className="card flex justify-content-center"
                style={{ marginRight: "30px", marginBottom: "5px" }}
              >
                <label style={{ display: "table" }} htmlFor="dd-city">
                  Cantidad
                </label>
                <InputNumber
                  ref={ref}
                  id="os_cantidad_0"
                  placeholder="Cantidad"
                  minFractionDigits={4}
                  locale="de-DE"
                  value={selectedCantidad}
                  min={0}
                  onValueChange={(e: any) => {
                    setSelectedCantidad(e.value);

                    handleQuantityChange(e.value ?? 0, 0);
                    if (
                      selectedCentroCostoId !== undefined &&
                      selectedItemId !== undefined
                    ) {
                      getPptoDisponibleValida(
                        selectedCentroCostoId,
                        selectedItemId,
                        0,
                        selectedMesGastoId,
                      ).then((validaMontoVsPpto) => {
                        const element = document.getElementById(
                          `os_precio_unitario_total_0`,
                        );
                        if (element) {
                          element.style.backgroundColor = validaMontoVsPpto;
                        }
                      });
                    }
                  }}
                  showButtons
                  buttonLayout="horizontal"
                  step={1}
                  decrementButtonClassName="p-button-danger"
                  incrementButtonClassName="p-button-success"
                  incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus"
                />
              </div>

              <div className="card flex justify-content-center">
                <FloatLabel className="w-full md:w-14rem">
                  <DropdownFilter
                    id={`os_centro_costo_0`}
                    labelHead=""
                    initialData={centrosCosto}
                    data={selectedCentroCosto}
                    dataId={selectedCentroCostoId}
                    handleUpdateItems={handleUpdateCentroFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                  <label htmlFor="dd-city">Centro de costo</label>
                </FloatLabel>
              </div>

              <div className="card flex justify-content-center">
                <FloatLabel className="w-full md:w-14rem">
                  <DropdownFilter
                    id={`os_item_0`}
                    labelHead=""
                    initialData={itemsFiltered.current}
                    data={selectedItem ?? ""}
                    dataId={selectedItemId ?? 0}
                    handleUpdateItems={handleUpdateItemFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                  <label htmlFor="dd-city">Items</label>
                </FloatLabel>
              </div>

              <div className="card flex justify-content-center">
                <FloatLabel className="w-full md:w-14rem">
                  <DropdownFilter
                    id={`os_proveedor_0`}
                    labelHead=""
                    initialData={proveedores}
                    data={selectedProveedor}
                    dataId={selectedProveedorId}
                    handleUpdateItems={handleUpdateProveedorFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                  <label htmlFor="dd-city">Proveedor</label>
                </FloatLabel>
              </div>
            </div>

            <div
              className="card flex justify-content-center"
              style={{
                marginLeft: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="rowEditData">
                <div
                  className="card flex justify-content-center"
                  style={{ marginRight: "10px" }}
                >
                  <label htmlFor="name" className="labelEditRow">
                    Precio ref. Unitario
                  </label>
                  <InputNumber
                    ref={ref}
                    id="os_precio_unitario_0"
                    value={selectedPrecioUnitarioRef}
                    placeholder="Ingresa el precio del item..."
                    minFractionDigits={4}
                    maxFractionDigits={4}
                    locale="de-DE"
                    min={0}
                    onValueChange={(e) => {
                      const value = e.target.value;
                      setselectedPrecioUnitarioRef(value ?? 0);

                      handlePrecioUnitarioChange(value ?? 0, 0);
                      if (
                        selectedCentroCostoId !== undefined &&
                        selectedItemId !== undefined
                      ) {
                        getPptoDisponibleValida(
                          selectedCentroCostoId,
                          selectedItemId,
                          0,
                          selectedMesGastoId,
                        ).then((validaMontoVsPpto) => {
                          const element = document.getElementById(
                            `os_precio_unitario_total_0`,
                          );
                          if (element) {
                            element.style.backgroundColor = validaMontoVsPpto;
                          }
                        });
                      }
                    }}
                  />
                </div>

                <div
                  className="card flex justify-content-center"
                  style={{ textAlign: "center" }}
                >
                  <label htmlFor="name" className="labelEditRow">
                    Precio ref. Total
                  </label>
                  <InputNumber
                    ref={ref}
                    id="os_precio_unitario_total_0"
                    value={selectedPrecioTotalRef}
                    minFractionDigits={4}
                    maxFractionDigits={4}
                    locale="de-DE"
                    min={0}
                    disabled
                  />
                  <span
                    id={`ppto_error_0`}
                    style={{ fontSize: "10px", color: "red" }}
                  ></span>
                </div>

                <div
                  className="card flex justify-content-center"
                  style={{ textAlign: "center" }}
                >
                  <label className="labelDialog">Usuario Aprobador</label>
                  <DropdownFilter
                    id={`os_usuario_aprobador_0`}
                    labelHead=""
                    initialData={aprobadores}
                    data={selectedAprobador}
                    dataId={selectedAprobadorId}
                    handleUpdateItems={handleUpdateAprobadoresFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div
                  className="card flex justify-content-center"
                  style={{ marginLeft: "20px", width: "100%" }}
                  onPaste={(e) => {
                    e.preventDefault();
                    showMsg(
                      toast,
                      "warn",
                      "Advertencia",
                      "El pegado de texto está deshabilitado para este campo.",
                    );
                  }}
                >
                  <label
                    htmlFor="name"
                    className="labelEditRow"
                    style={{ display: "table-caption" }}
                  >
                    Detalles Adicionales
                    {textAreaRender()}
                  </label>
                </div>
              </div>
            </div>
            <div className="rowEditData" style={{ marginTop: "0px" }}>
              <Button
                className="buttonformrow"
                style={{ width: "50%", margin: "10px", textAlign: "center" }}
                onClick={saveNewDetail}
              >
                Guardar cambios
              </Button>
            </div>
          </div>
        </Dialog>

        {showModalConfirm ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ModalConfirm
              header="Confirmación"
              text="¿Estás seguro de editar la solicitud?"
              show={true}
              setShowModalConfirm={setShowModalConfirm}
              setDocId={0}
              setNeedFetchingDoc={setNeedFetchingSoc}
              data={jsonDataSolicitud}
              jsonDestination="editasolicitud"
              data2=""
              setGoHome={setGoHome}
            />
          </div>
        ) : null}

        {showModalConfirmNewDetail ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ModalConfirm
              header="Confirmación"
              text="¿Estás seguro de agregar el nuevo detalle a la solicitud?"
              show={true}
              setShowModalConfirm={setShowModalConfirmNewDetail}
              setDocId={0}
              setNeedFetchingDoc={setNeedFetchingSoc}
              data={jsonDataSolicitud}
              jsonDestination="nvodetallesolicitud"
              data2=""
              setGoHome={setGoHome}
            />
          </div>
        ) : null}

        <div style={{ display: "flex" }}>
          <h5>Detalle del número solicitud: {data.soc_id} </h5>

          {contextmenu == "mantiene" ? (
            <Button
              label="Nuevo Detalle"
              icon="pi pi-plus"
              severity="success"
              onClick={() => addNewDetail(data)}
              style={{
                height: "40px",
                marginLeft: "15px",
                marginRight: "5px",
                padding: "5px",
              }}
            />
          ) : null}
          {
            //data.socest_id < 7 ? (
            <Button
              label="SOC PDF ↓"
              className="btnArchivoDialog"
              onClick={() => {
                fetchDatosAprobacionesConfirmaciones(data.soc_id).then(() => {
                  fetchDatosFirmaAprobacionesConfirmaciones(data.soc_id).then(
                    () => {
                      PdfCreator({
                        data: data,
                        initData: initData,
                        solicitudesApprovalStates:
                          solicitudesApprovalStates.current ?? [],
                        solicitudesSignApprovalHistory:
                          solicitudesSignApprovalHistory.current ?? [],
                      });
                    },
                  );
                });
              }}
            />

            /*) : (
            <DownloadFiles
              path={`solicitudes/${ano}/${mes}/${data.soc_id}/pdf`}
              numDoc={data.soc_id}
              className="btnArchivoDialog"
              pdf={true}
            ></DownloadFiles>
          )*/
          }

          <p
            style={{
              color: "black",
              fontSize: "8px",
              margin: 0,
              fontWeight: "normal",
            }}
          >
            {archivoBodyTemplate(data)}
          </p>
        </div>

        <Dialog
          header="Subir archivos a la solicitud"
          visible={dialogVisible}
          style={{ width: "55vw" }}
          modal
          contentStyle={{ height: "400px" }}
          onHide={() => setDialogVisible(false)}
        >
          <UploadFile
            typeDoc="solicitudes"
            id={data.soc_id}
            ano={ano}
            mes={mes}
            setDialogVisible={setDialogVisible}
          />
        </Dialog>

        <Dialog
          id="dialogEditionSolicitude"
          className="oc-estado-dialog oc-estado--red"
          maskClassName="oc-estado-dialog-mask"
          header={
            <div className="oc-estado-header">
              <span className="oc-estado-header__icon">
                <i className="pi pi-check-square" />
              </span>
              <div className="oc-estado-header__text">
                <span className="oc-estado-header__eyebrow">
                  Cambio de estado
                </span>
                <span className="oc-estado-header__title">
                  Solicitud N° {selectedNumeroSolicitud}
                </span>
              </div>
            </div>
          }
          visible={dialogEditaEstadoSol}
          modal
          blockScroll
          draggable={false}
          onHide={() => setDialogEditaEstadoSol(false)}
          footer={
            <div className="oc-estado-footer">
              <Button
                type="button"
                label="Cancelar"
                icon="pi pi-times"
                className="oc-estado-btn oc-estado-btn--ghost"
                onClick={() => setDialogEditaEstadoSol(false)}
              />
              {initData?.firma !== null ? (
                <Button
                  type="button"
                  label="Guardar estado"
                  icon="pi pi-save"
                  className="oc-estado-btn oc-estado-btn--primary"
                  onClick={() => {
                    setShowModalLoadSpinner(true);
                    sendNewApprovalStateSolicitude(data);
                  }}
                  disabled={initData?.firma === "" ? true : false}
                />
              ) : null}
            </div>
          }
        >
          <div className="oc-estado-body">
            <section className="oc-estado-resumen" id="pDialogEditSolicitude">
              <div className="oc-estado-resumen__top">
                <span className="oc-estado-chip">
                  <i className="pi pi-hashtag" />
                  Detalle {selectedRow?.socdet_id}
                </span>
                <span className="oc-estado-resumen__hint">
                  Monto solicitado
                </span>
              </div>
              <div className="oc-estado-resumen__monto">
                {formatCurrency(
                  parseFloat(selectedRow?.socdet_precio_total_ref ?? "0"),
                )}
                <span className="oc-estado-resumen__moneda">
                  {data.tipmon_nombre}
                </span>
              </div>
              <div className="oc-estado-resumen__cc">
                <i className="pi pi-building" />
                <span>
                  Centro de costo:{" "}
                  <strong>{selectedRow?.sdetcc2_nombre}</strong>
                </span>
              </div>
            </section>

            <div className="oc-estado-field">
              <span className="oc-estado-label" id="oc-estado-label-estado">
                Nuevo estado
              </span>
              <DropdownFilter
                id="os_estado_solicitud_0"
                labelHead=""
                className="oc-estado-dropdown"
                panelClassName="oc-estado-dropdown-panel oc-estado--red"
                virtualScroll={false}
                filterInputAutoFocus={false}
                initialData={
                  initData.roles.some(
                    (role: { codigo: string }) =>
                      role.codigo === "APRSOC" && contextmenu == "aprueba",
                  )
                    ? estadosSolicitud.filter(
                        (element) => ![3, 5, 7, 8, 9, 10].includes(element.id),
                      )
                    : initData.roles.some(
                          (role: { codigo: string }) =>
                            role.codigo === "CONFSOC" &&
                            contextmenu == "confirma",
                        )
                      ? !USUARIO_CONFIRMA_GTE_GENERAL.includes(initData.id)
                        ? estadosSolicitud.filter(
                            (element) =>
                              ![3, 5, 6, 7, 9, 10].includes(element.id),
                          )
                        : estadosSolicitud.filter(
                            (element) => ![3, 5, 6, 7, 9].includes(element.id),
                          )
                      : null
                }
                data={selectedEstado}
                dataId={selectedEstadoId}
                handleUpdateItems={handleUpdateEstadoFromChild}
                idRow={0}
                virtualScrollerOptions={{ itemSize: 100 }}
              />
            </div>

            {initData?.firma == null ? (
              <div className="oc-estado-firma">
                <i className="pi pi-pencil" />
                <div className="oc-estado-firma__text">
                  <strong>Necesitas una firma digital</strong>
                  <span>
                    Créala para poder guardar el estado de la solicitud.
                  </span>
                </div>
                <Button
                  type="button"
                  label="Crea tu firma"
                  className="oc-estado-btn oc-estado-btn--secondary"
                  onClick={() => setShowModalFirma(true)}
                />
              </div>
            ) : null}

            {showModalFirma ? (
              <ModalSignature setShowModalSignature={setShowModalFirma} />
            ) : null}

            <div className="oc-estado-field" id="taDialogEditSolicitude">
              <span className="oc-estado-label" id="oc-estado-label-just">
                Justificaciones
              </span>
              <div
                contentEditable="true"
                suppressContentEditableWarning={true}
                role="textbox"
                aria-multiline="true"
                aria-labelledby="oc-estado-label-just"
                data-placeholder="Escribe aquí la justificación del cambio de estado..."
                className="oc-estado-textarea"
                id="os_justificacion"
                onChange={(e) => handleUpdateJustificacion(e)}
              >
                {selectedJustificacion.current}
              </div>
            </div>
          </div>
        </Dialog>

        <Dialog
          header={`Edición de detalle de solicitud N° ${selectedNumeroSolicitud}`}
          visible={dialogEditaDetalleVisible}
          style={{ width: "40%" }}
          maximizable
          modal
          contentStyle={{ height: "60vw" }}
          onHide={() => setDialogEditaDetalleVisible(false)}
        >
          {selectedRow != null ? (
            <div className="card flex justify-content-center">
              <div className="rowEditData">
                <div className="card flex justify-content-center">
                  <label className="labelDialog">Tipo Solicitud</label>
                  <DropdownFilter
                    id="os_tipo_solicitud_0"
                    labelHead=""
                    initialData={tipoSolicitudes}
                    data={selectedTipoSolicitud}
                    dataId={selectedTipoSolicitudId}
                    handleUpdateItems={handleUpdateTipoSolFromChild}
                    idRow={0}
                    disabled={true}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Mes Gasto</label>
                  <DropdownFilter
                    id={`os_mes_0`}
                    labelHead=""
                    initialData={meses}
                    data={selectedMesGasto}
                    dataId={selectedMesGastoId}
                    handleUpdateItems={handleUpdateMesFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Estado Operacional</label>
                  <DropdownFilter
                    id="os_estado_operacion_0"
                    labelHead=""
                    initialData={estadosOperacionales}
                    data={selectedEstadoOp}
                    dataId={selectedEstadoOpId}
                    handleUpdateItems={handleUpdateEstadoOpeFromChild}
                    idRow={0}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Tipo Moneda</label>
                  <DropdownFilter
                    id="os_tipo_moneda_0"
                    labelHead=""
                    initialData={tiposMoneda}
                    data={selectedTipoMoneda}
                    dataId={selectedTipoMonedaId}
                    handleUpdateItems={handleUpdateTipoMonFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>
              </div>
              <div className="rowEditData" style={{ marginBottom: "0px" }}>
                <div
                  className="card flex justify-content-center"
                  style={{ marginRight: "20px" }}
                >
                  <label className="labelDialog">Cantidad</label>
                  <InputNumber
                    ref={ref}
                    id="os_cantidad_0"
                    placeholder="Cantidad"
                    minFractionDigits={4}
                    locale="de-DE"
                    value={selectedCantidad}
                    min={0}
                    onValueChange={(e: any) => {
                      setSelectedCantidad(e.value);

                      handleQuantityChange(e.value ?? 0, 0);
                      if (
                        selectedCentroCostoId !== undefined &&
                        selectedItemId !== undefined
                      ) {
                        getPptoDisponibleValida(
                          selectedCentroCostoId,
                          selectedItemId,
                          0,
                          selectedMesGastoId,
                        ).then((validaMontoVsPpto) => {
                          const element = document.getElementById(
                            `os_precio_unitario_total_0`,
                          );
                          if (element) {
                            element.style.backgroundColor = validaMontoVsPpto;
                          }
                        });
                      }
                    }}
                    showButtons
                    buttonLayout="horizontal"
                    step={1}
                    decrementButtonClassName="p-button-danger"
                    incrementButtonClassName="p-button-success"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Centro de costo</label>
                  <DropdownFilter
                    id={`os_centro_costo_0`}
                    labelHead=""
                    initialData={centrosCosto}
                    data={selectedCentroCosto}
                    dataId={selectedCentroCostoId}
                    handleUpdateItems={handleUpdateCentroFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Items</label>
                  <DropdownFilter
                    id={`os_item_0`}
                    initialData={itemsFiltered.current}
                    data={selectedItem ?? ""}
                    dataId={selectedItemId ?? 0}
                    handleUpdateItems={handleUpdateItemFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>

                <div className="card flex justify-content-center">
                  <label className="labelDialog">Proveedor</label>
                  <DropdownFilter
                    id={`os_proveedor_0`}
                    labelHead=""
                    initialData={proveedores}
                    data={selectedProveedor}
                    dataId={selectedProveedorId}
                    handleUpdateItems={handleUpdateProveedorFromChild}
                    idRow={0}
                    virtualScrollerOptions={{ itemSize: 100 }}
                  />
                </div>
              </div>

              <div
                className="card flex justify-content-center"
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className="rowEditData">
                  <div className="card flex justify-content-center">
                    <label htmlFor="name" className="labelEditRow">
                      Precio ref. Unitario
                    </label>
                    <InputNumber
                      ref={ref}
                      id="os_precio_unitario_0"
                      value={selectedPrecioUnitarioRef}
                      placeholder="Ingresa el precio del item..."
                      minFractionDigits={4}
                      maxFractionDigits={4}
                      locale="de-DE"
                      min={0}
                      onValueChange={(e) => {
                        const value = e.target.value;
                        setselectedPrecioUnitarioRef(value ?? 0);

                        handlePrecioUnitarioChange(value ?? 0, 0);
                        if (
                          selectedCentroCostoId !== undefined &&
                          selectedItemId !== undefined
                        ) {
                          getPptoDisponibleValida(
                            selectedCentroCostoId,
                            selectedItemId,
                            0,
                            selectedMesGastoId,
                          ).then((validaMontoVsPpto) => {
                            const element = document.getElementById(
                              `os_precio_unitario_total_0`,
                            );
                            if (element) {
                              element.style.backgroundColor = validaMontoVsPpto;
                            }
                          });
                        }
                      }}
                    />
                  </div>

                  <div
                    className="card flex justify-content-center"
                    style={{ textAlign: "center" }}
                  >
                    <label htmlFor="name" className="labelEditRow">
                      Precio ref. Total
                    </label>
                    <InputNumber
                      ref={ref}
                      id="os_precio_unitario_total_0"
                      value={selectedPrecioTotalRef}
                      minFractionDigits={4}
                      maxFractionDigits={4}
                      locale="de-DE"
                      min={0}
                      disabled
                    />
                    <span
                      id={`ppto_error_0`}
                      style={{ fontSize: "10px", color: "red" }}
                    ></span>
                  </div>

                  <div
                    className="card flex justify-content-center"
                    style={{ textAlign: "center" }}
                  >
                    <label className="labelDialog">Usuario Aprobador</label>
                    <DropdownFilter
                      id={`os_usuario_aprobador_0`}
                      labelHead=""
                      initialData={aprobadores}
                      data={selectedAprobador}
                      dataId={selectedAprobadorId}
                      handleUpdateItems={handleUpdateAprobadoresFromChild}
                      idRow={0}
                      virtualScrollerOptions={{ itemSize: 100 }}
                    />
                  </div>

                  <div
                    className="card flex justify-content-center"
                    style={{ marginLeft: "20px", width: "100%" }}
                    onPaste={(e) => {
                      e.preventDefault();
                      showMsg(
                        toast,
                        "warn",
                        "Advertencia",
                        "El pegado de texto está deshabilitado para este campo.",
                      );
                    }}
                  >
                    <label
                      htmlFor="name"
                      className="labelEditRow"
                      style={{ display: "table-caption" }}
                    >
                      Detalles Adicionales
                      {textAreaRender()}
                    </label>
                  </div>
                </div>
              </div>

              <div className="rowEditData" style={{ marginTop: "0px" }}>
                <Button
                  className="buttonformrow"
                  style={{ width: "50%", margin: "10px", textAlign: "center" }}
                  onClick={saveSolicitudEdition}
                >
                  Guardar cambios
                </Button>
              </div>
            </div>
          ) : null}
        </Dialog>
        <DataTable
          value={data.detalle}
          selectionMode="single"
          selection={selectedRow}
          onSelectionChange={(e: any) => {
            //AQUI ENTRA LOS ROLES POR USUARIOS QUE PUEDEN EDITAR SU SOLICITUD CENTRO O USUARIOS QUE APRUEBAN //
            // LOS QUE APRUEBAN NO EDITAN DATOS , LOS QUE EDITAN DATOS NO APRUEBAN //
            const dataVal = e.value;
            setSelectedRow(dataVal);
            setSelectedNumeroSolicitud(data.soc_id);

            if (dataVal.socest_id > 6) {
              showMsg(
                toast,
                "warn",
                "Advertencia",
                "No se pueden editar detalles de una solicitud confirmada",
              );
              return;
            }
            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "MANSOC",
              ) &&
              data.user_id === initData.id &&
              contextmenu == "mantiene"
            ) {
              if (
                dataVal.socest_id == 6 ||
                dataVal.socest_id == 8 ||
                dataVal.socest_id == 10
              ) {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de solicitudes que se encuentren aprobadas o confirmadas.",
                );
              } else if (dataVal.socest_id == 2 || dataVal.socest_id == 4) {
                showMsg(
                  toast,
                  "warn",
                  "Advertencia",
                  "No puedes editar detalles de solicitudes que se encuentren rechazadas o anuladas.",
                );
              } else {
                setSelectedMesGasto(data.meses_nombre);
                setSelectedMesGastoId(data.meses_id);
                setSelectedEStadoOp(data.estope_nombre);
                setSelectedEstadoOpId(data.estope_id);
                setSelectedTipoMoneda(data.tipmon_nombre);
                setSelectedTipoMonedaId(data.tipmon_id);
                setSelectedTipoSolicitud(data.subdoc_nombre);
                setSelectedTipoSolicitudId(data.subdoc_id);

                itemsFiltered.current = FILTER_ITEMS_BY_DOC_TYPE(
                  itemsAdquisicion,
                  data.subdoc_id,
                  tiposItemsAdquisicion,
                );

                const usuarioAprobadorTabla =
                  aprobadoresFull.find(
                    (aprobador) =>
                      aprobador.id_usuario === dataVal.suda_id_usuario,
                  )?.id ?? 0;

                setSelectedAprobadorId(usuarioAprobadorTabla);

                setSelectedAprobador(
                  aprobadores.find(
                    (aprobador) =>
                      aprobador.id === (usuarioAprobadorTabla as number),
                  )?.nombre ?? "",
                );
                //setSelectedAprobador(dataVal.suda_nombre_usuario);
                //setSelectedAprobadorId(dataVal.suda_id_usuario);
                setSelectedDetailRowId(data.socdet_id);
                setSelectedEstado(data.socest_nombre);
                setSelectedEstadoId(data.socest_id);
                setSelectedCantidad(dataVal.socdet_cantidad);
                setSelectedCentroCosto(dataVal.sdetcc2_nombre);
                setSelectedCentroCostoId(dataVal.sdetcc2_id);
                setSelectedProveedor(dataVal.prov_nombre);
                setSelectedProveedorId(dataVal.prov_id);

                setSelectedItem(dataVal.item_nombre);
                setSelectedItemId(dataVal.item_id);
                setSelectedEstado(dataVal.socest_nombre);
                setSelectedEstadoId(dataVal.socest_id);
                setselectedPrecioUnitarioRef(
                  dataVal.socdet_precio_unitario_ref,
                );
                setSelectedPrecioTotalRef(dataVal.socdet_precio_total_ref);
                selectedDetalles.current = dataVal.socdet_observaciones;
                setSelectedDetailRowId(dataVal.socdet_id);

                setDialogEditaDetalleVisible(true);
              }
            }

            if (
              data.user_id !== initData.id &&
              contextmenu == "mantiene" &&
              initData.id !== USUARIO_TI
            ) {
              showMsg(
                toast,
                "warn",
                "Advertencia",
                "No puedes editar detalles de solicitudes que no has creado.",
              );
            }

            //MENSAJES INFORMATIVOS APROBADOR
            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "APRSOC",
              ) &&
              contextmenu == "aprueba"
            ) {
              if (
                data.user_id === initData.id &&
                initData.crear_aprobar_solicitud == 1
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes aprobar detalles de solicitudes que hayas creado.",
                );
              } else if (
                dataVal.sdetcc2_id !== initData.id_centro_costo &&
                initData.crear_aprobar_solicitud == 1
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes aprobar detalles de solicitudes que no pertenencen a tu centro de costo.",
                );
              }
              //PENDIENTE, RECHAZADA, PARCIALMENTE RECHAZADA
              else if (
                dataVal.socest_id !== 1 &&
                dataVal.socest_id !== 3 &&
                dataVal.socest_id !== 4 &&
                data.socest_id !== 6 &&
                data.socest_id !== 5
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No tienes permisos para confirmar detalles de una solicitud",
                );
              } else {
                setDialogEditaEstadoSol(true);
              }
            }
            //MENSAJES INFORMATIVOS CONFIRMADOR
            if (
              initData.roles.some(
                (role: { codigo: string }) => role.codigo === "CONFSOC",
              ) &&
              contextmenu == "confirma"
            ) {
              if (data.user_id === initData.id && initData.id !== USUARIO_TI) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de solicitudes que hayas creado.",
                );
              } else if (
                dataVal.sdetcc2_id !== initData.id_centro_costo &&
                initData.id_centro_costo != CENTRO_COSTO_ADQUISICION &&
                initData.id !== USUARIO_TI
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de solicitudes que no pertenencen a tu centro de costo.",
                );
              }

              //APROBADA, PARCIALMENTE APROBADA, CONFIRMADA PARCIALMENTE
              else if (
                dataVal.socest_id !== 5 &&
                dataVal.socest_id !== 6 &&
                dataVal.socest_id !== 7 &&
                data.socest_id !== 8
              ) {
                showMsg(
                  toast,
                  "info",
                  "Información",
                  "No puedes confirmar detalles de solicitudes que no estén aprobadas",
                );
              } else {
                setDialogEditaEstadoSol(true);
              }
            }
          }}
          dataKey="socdet_id"
          metaKeySelection={false}
          tableStyle={{ minWidth: "30rem" }}
        >
          <Column
            field="socdet_id"
            header="Id"
            style={{ maxWidth: "2rem" }}
            sortable
          ></Column>
          <Column
            field="socdet_cantidad"
            header="Cantidad"
            style={{ maxWidth: "4rem" }}
            sortable
          ></Column>
          <Column
            field="sdetcc2_nombre"
            header="Centro Costo"
            style={{ maxWidth: "5rem" }}
            sortable
          ></Column>
          <Column
            field="item_nombre"
            header="Item"
            style={{ maxWidth: "6rem" }}
            sortable
          ></Column>
          <Column
            field="prov_nombre"
            header="Proveedor"
            style={{ maxWidth: "6rem" }}
            sortable
          ></Column>

          <Column
            field="socdet_precio_unitario_ref"
            header="Precio ref. Unitario"
            sortable
            body={precioUniBodyTemplateLocal} // <--- Usar la versión local
            style={{ maxWidth: "4rem" }}
            showFilterMenu={false}
          ></Column>
          <Column
            field="socdet_precio_total_ref"
            header="Precio ref. Total"
            body={precioTotBodyTemplateLocal} // <--- Usar la versión local
            showFilterMenu={false}
            style={{ maxWidth: "4rem" }}
          ></Column>
          <Column
            body={() => data.tipmon_codigo}
            style={{
              width: "3rem",
              fontWeight: "bold",
              fontSize: "9px",
            }}
          ></Column>
          <Column
            field="socest_nombre"
            header="Estado"
            body={estadoBodyTemplate}
            sortable
            style={{ maxWidth: "4rem" }}
          ></Column>
          <Column
            field="suda_nombre_usuario"
            header="Aprobador"
            sortable
            style={{ maxWidth: "4rem" }}
          ></Column>
          <Column
            field="socdet_observaciones"
            header="Detalles"
            sortable
            style={{ maxWidth: "7rem" }}
          ></Column>
        </DataTable>
      </div>
    );
  };

  //************************************************************************************************/
  //************************************************************************************************/
  //************************************************************************************************/

  // Icono de la cabecera segun el contexto de la pantalla
  const iconoCabecera =
    contextmenu == "aprueba"
      ? "pi-check-square"
      : contextmenu == "confirma"
        ? "pi-verified"
        : "pi-pencil";

  const header = (
    <div className="om-header">
      <header className="om-hero om-hero--solicitudes">
        <div className="om-hero-main">
          <div className="om-hero-icon" aria-hidden="true">
            <i className={`pi ${iconoCabecera}`} />
          </div>
          <div className="om-hero-text">
            <span className="om-eyebrow">Compras · Solicitudes de compra</span>
            <h2 className="om-title">
              {contextmenu == "confirma"
                ? "Confirmación de solicitudes de orden de compra"
                : null}
              {contextmenu == "aprueba"
                ? "Aprobación de solicitudes de orden de compra"
                : null}
              {contextmenu == "mantiene"
                ? "Edición de solicitudes de orden de compra"
                : null}
            </h2>
            <p className="om-hero-desc">
              {contextmenu == "mantiene"
                ? "En este módulo podrá editar solicitudes de compra, visualizar en pdf, adjuntar y descargar archivos en las solicitudes."
                : null}
              {contextmenu == "aprueba"
                ? "En este módulo podrá aprobar solicitudes de compra correspondientes a su rol, visualizar en pdf, adjuntar y descargar archivos en las solicitudes."
                : null}
              {contextmenu == "confirma"
                ? "En este módulo podrá confirmar solicitudes de compra correspondientes a su rol, visualizar en pdf, adjuntar y descargar archivos en las solicitudes."
                : null}
            </p>
          </div>
        </div>
        <EstadosSolicitudLeyenda />
      </header>

      <section className="om-filtros" aria-label="Filtros avanzados">
        <div className="om-filtros-head">
          <span className="om-filtros-title">
            <i className="pi pi-sliders-h" aria-hidden="true" />
            Filtros avanzados
          </span>
        </div>
        <div className="eol-toolbar om-toolbar" style={{ marginLeft: "15px" }}>
          <div className="eol-filtro">
            <label htmlFor="filtro_centro_costo_destino">
              Centro Costo Destino
            </label>
            <span className="eol-filtro-input">
              <i className="pi pi-search" aria-hidden="true" />
              <InputText
                id="filtro_centro_costo_destino"
                value={filters.centros_costo_destino?.value ?? ""}
                onChange={(e) => onCentroCostoDestinoChange(e.target.value)}
                placeholder="Nombre o código del centro de costo"
                title="Busca solicitudes por el centro de costo de sus líneas de detalle (no el del solicitante)"
              />
              {filters.centros_costo_destino?.value ? (
                <button
                  type="button"
                  className="eol-filtro-limpiar"
                  onClick={() => onCentroCostoDestinoChange("")}
                  aria-label="Limpiar filtro Centro Costo Destino"
                >
                  <i className="pi pi-times" style={{ fontSize: "0.7rem" }} />
                </button>
              ) : null}
            </span>
          </div>

          {/*<Button style={{width: '55px', height: '30px', backgroundColor: 'green', marginBottom: '10px', marginRight: '5px'}} type="button" icon="pi pi-file" rounded onClick={exportCSV(false)} data-pr-tooltip="CSV">CSV</Button>*/}
          <div className="om-descarga">
            <Button
              className="om-btn-excel"
              type="button"
              icon="pi pi-download"
              onClick={exportExcel}
              data-pr-tooltip="XLS"
              title="Descarga en un archivo Excel todas las solicitudes de la tabla (sin aplicar filtros): hoja Cabecera SOC y hoja Detalles SOC"
            >
              Descargar Excel
            </Button>
            <span className="om-descarga-nota">
              <i className="pi pi-file-excel" aria-hidden="true" /> Toda la
              tabla: cabecera y detalle de las solicitudes
            </span>
          </div>
        </div>
      </section>

      {/*<Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} data-pr-tooltip="PDF" />*/}
    </div>
  );

  return (
    <div
      className="card om-screen"
      style={{
        padding: "20px calc(20px + var(--rp-scrollbar-width, 0px)) 20px 20px",
      }}
    >
      {showModalLoadSpinner ? <ModalLoadSpinner /> : null}
      <Toast ref={toast} />

      <Tooltip target=".export-buttons>button" position="bottom" />
      {cargandoDatos ? (
        <CargandoDatos
          mensaje="Cargando los datos de las solicitudes"
          icono="pi-file-edit"
          tema="solicitudes"
        />
      ) : (
        <DataTable
          value={data}
          paginator
          rows={10}
          dataKey="soc_id"
          filters={filters}
          onFilter={onFilterChange}
          filterDisplay="row"
          loading={isLoading}
          globalFilterFields={[
            "tipmon_nombre",
            "subdoc_nombre",
            "item_nombre",
            "soc_id",
            "nombres",
            "apellidos",
            "cc_nombre",
            "soc_dt_cre",
            "soc_precio_total_ref",
            "socest_nombre",
            "item_nombre",
            "detalle.prov_nombre",
          ]}
          header={header}
          emptyMessage="No se encontraron solicitudes..."
          expandedRows={expandedRows}
          onRowToggle={(e) => {
            setExpandedRows(e.data as DataTableExpandedRows[] | undefined);
          }}
          onRowExpand={onRowExpand}
          onRowCollapse={onRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
        >
          <Column body={togglerTemplate} style={{ maxWidth: "3rem" }} />
          {/*<Column
          field="tipmon_nombre"
          header="Tipo Moneda"
          filter
          filterPlaceholder="Buscar Moneda"
          filterMenuStyle={{ width: "12rem" }}
          style={{ minWidth: "12rem" }}
        />*/}

          <Column
            field="detalle" // Points to the array in the main object
            header="Proveedor"
            style={{ minWidth: "10rem" }}
            filter
            filterMatchMode="custom_detail_proveedor_filter"
            filterPlaceholder="Proveedor..."
            body={mainProveedorTemplate} // Shows info in the main row
            showFilterMenu={false}
          />
          <Column
            field="subdoc_nombre"
            header="Tipo Soc"
            filter
            filterPlaceholder="Tipo..."
            style={{ maxWidth: "8rem" }}
            showFilterMenu={false}
          />
          <Column
            field="soc_id"
            header="N° Solicitud"
            filter
            filterPlaceholder="N° Soc..."
            style={{ maxWidth: "7rem" }}
            showFilterMenu={false}
          />
          <Column
            field="oc_id"
            header="N° Orden"
            filter
            filterPlaceholder="N° Orden..."
            style={{ maxWidth: "7rem" }}
            showFilterMenu={false}
          />
          <Column
            field="busqueda_solicitante" /* Usamos tu campo existente */
            header="Solicitante / Centro"
            body={solicitanteFusionadoBodyTemplate}
            filter
            filterFunction={
              filtroNombreOCentro
            } /* Agregamos la regla "O" (OR) */
            filterElement={singleFilterSolicCentroElement}
            filterMatchMode="custom_detail_proveedor_filter"
            showFilterMatchModes={false}
            showApplyButton={false}
            showClearButton={false}
            style={{ maxWidth: "10rem" }}
            showFilterMenu={false}
          />
          <Column
            field="soc_dt_cre"
            header="Fecha Creación"
            filter
            filterPlaceholder="Fecha..."
            style={{ maxWidth: "8rem" }}
            showFilterMenu={false}
          />
          <Column
            field="soc_precio_total_ref"
            header="Precio Ref. Total"
            body={precioTotalTemplate}
          />
          <Column
            header="Estado Solicitud"
            field="socest_nombre"
            showFilterMenu={false}
            style={{ maxWidth: "8rem" }}
            body={estadoBodyTemplate}
            filter
            filterPlaceholder="Estado..."
            filterElement={estadoRowFilterTemplate}
          />
          <Column
            header="Aprobador"
            field="aprobadores_combinados"
            body={aprobadorBodyTemplate}
            filter
            //filterFunction={filtroAprobador} /* Agregamos la regla "O" (OR) */
            //filterElement={singleFilterAprobadorElement}
            filterMatchMode="custom_detail_aprobador_filter"
            filterPlaceholder="Nombre..."
            showFilterMatchModes={false}
            showApplyButton={false}
            showClearButton={false}
            style={{ maxWidth: "6rem" }}
            showFilterMenu={false}
          />

          <Column
            field="estope_nombre"
            header="Estado Oper."
            style={{ maxWidth: "6rem" }}
          />
        </DataTable>
      )}
    </div>
  );
}

export default TableDataMaintenance;
